var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationArrowOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8273 2.10003C20.9607 2.20592 21.0366 2.38696 20.9822 2.58513L15.44 21.6662C15.3607 21.9551 15.0415 22.0786 14.7943 21.9481C14.7445 21.9219 14.694 21.8917 14.6627 21.8446C14.2027 21.152 12.1301 14.2541 12.083 14.0974C12.0815 14.0923 12.0813 14.0922 12.0794 14.0872C12.0456 14.0013 11.9371 13.8018 11.8056 13.6972C11.675 13.5933 11.4569 13.5335 11.3683 13.521C11.3637 13.5204 11.364 13.5203 11.3594 13.52C11.2208 13.511 4.19406 13.0544 3.27076 12.7527C3.19796 12.7289 3.1323 12.6661 3.08697 12.6039C2.93108 12.3898 2.98769 12.0671 3.23328 11.9255L20.3235 2.05993C20.4986 1.95894 20.6944 1.99455 20.8273 2.10003ZM7.74839 11.0877C7.53896 11.2085 7.60372 11.5292 7.84329 11.5576L12.8411 12.1498C12.9353 12.161 13.0151 12.225 13.0472 12.3151L14.7335 17.0485C14.8153 17.2782 15.1403 17.2685 15.2085 17.0343L18.6253 5.31116C18.6889 5.09304 18.4569 4.90786 18.2615 5.02067L7.74839 11.0877Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationArrowOutline);
export default __webpack_public_path__ + "static/media/LocationArrowOutline.939965aa307f95b6c7ed1b2851101b70.svg";
export { ForwardRef as ReactComponent };